import { render, staticRenderFns } from "./AutocompleteCities.vue?vue&type=template&id=632d6bb3&"
import script from "./AutocompleteCities.vue?vue&type=script&lang=js&"
export * from "./AutocompleteCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports